module.exports = __webpack_public_path__ + "banner-bg.b6d5c93d63c5bf8b3f39.png";


//////////////////
// WEBPACK FOOTER
// /Users/tom/Projects/mercit2018/src/assets/img/banner-bg.png
// module id = ../../../../../src/assets/img/banner-bg.png
// module chunks = styles